<section class="tags-panel">
  <p class="mt-0 text-base">Select tags</p>
  <mat-divider class="mt-1 mb-2"></mat-divider>
  <ng-container *ngIf="tags$ | async as tags; else LoadingOrError">
    <article class="tags">
      <ng-container *ngIf="isTagListResponseEmpty(tags)">
        <app-alert-banner [type]="'warning'">
          <p>No tags found.</p>
        </app-alert-banner>
      </ng-container>
      <ng-container *ngIf="!isTagListResponseEmpty(tags)">
        <ng-container *ngFor="let tag of tags | keyvalue">
          <div class="tag" [ngClass]="{ selected: isTagSelected(tag.key) }">
            <span class="tag-title" (click)="toggleSelectedTag(tag.key)">{{ tag.key }}</span>
          </div>
        </ng-container>
      </ng-container>
    </article>
  </ng-container>
</section>

<ng-template #LoadingOrError>
  <ng-container *ngIf="tagsError$ | async; else Loading">
    <app-alert-banner [type]="'error'">
      <p>Unable to fetch tags list at the moment. Please try again later.</p>
    </app-alert-banner>
  </ng-container>
  <ng-template #Loading>
    <mat-spinner class="my-0 mx-auto" [diameter]="36" [strokeWidth]="3"></mat-spinner>
  </ng-template>
</ng-template>
